/** @cf/baai/bge-m3 dense output size. Changing models requires a new vector column. */
export const DEFAULT_EMBED_MODEL = "@cf/baai/bge-m3";
export const DEFAULT_EMBED_DIMENSIONS = 1024;

/**
 * Instruction-following chat model. Not a reasoning model, so customer replies
 * are not prefixed with a chain-of-thought trace.
 */
export const DEFAULT_CHAT_MODEL = "@cf/meta/llama-3.3-70b-instruct-fp8-fast";

export const MAX_UPLOAD_BYTES = 8 * 1024 * 1024;
export const MAX_PAGE_BYTES = 1_500_000;
export const MAX_EXTRACTED_CHARS = 400_000;
export const CHUNK_SIZE = 1200;
export const CHUNK_OVERLAP = 200;
export const MAX_CHUNKS_PER_DOCUMENT = 200;
export const MIN_SIMILARITY = 0.35;
export const MATCH_COUNT = 5;
export const MAX_MATCH_COUNT = 20;
export const WIDGET_TOKEN_TTL_SECONDS = 15 * 60;
export const MAX_VISITOR_MESSAGE_CHARS = 2000;
export const MAX_HISTORY_MESSAGES = 8;

export const DEFAULT_THEME = {
  color: "#ef5b25",
  greeting: "Hi, what can we help you with?",
  avatarUrl: null,
  title: null,
} as const;
